import * as d3 from 'd3'

export default {
  methods: {

    draw_Legends() {

      let item = this.canvasForms
      .append('g')
      .attr('id', `LEGEND_GROUP_${this.localId}`)
      .attr('transform', `translate(${this.chart.x+1}, ${this.legends.y})`)
      
      let actData = this.chartData.find(f=> f.CDATE == this.cutoff)
      this.draw_LegendUp(item, this.chart.styles.filter(f=> f.dir == 'UP'), actData)
      this.draw_LegendDown(item, this.chart.styles.filter(f=> f.dir == 'DOWN'), actData)
    },


    draw_LegendUp(selection, data, actData) {

      let up = selection
      .append('g')
      .attr('transform', `translate(0,0)`)

      let x_ = 0
      data.forEach(d=> {
        up
        .append('rect')
        .attr('id', `ICON_${d.code}_${this.localId}`)
        .attr('x', x_)
        .attr('y', (d.type=='LINE') ? 3 : 0)
        .attr('width', 6)
        .attr('height', (d.type=='LINE') ? 1 : 6)
        .attr('fill', d.color).attr('stroke', d.color)

        up
        .append('text')
        .attr('id', `LEGEND_${d.code}_${this.localId}`)
        .attr('transform', `translate(${x_ + 10}, ${3 + this.legends.tSize*0.36})`)
        .attr('font-size', this.legends.tSize).attr('fill', this.legends.tColor)
        .text(`${d.name} (${actData[d.code]})`)

        x_ = x_ + this.getNode(`#LEGEND_${d.code}_${this.localId}`, 'width') + 25
      })
    },


     draw_LegendDown(selection, data, actData) {

      let down = selection
      .append('g')
      .attr('transform', `translate(0,15)`)

      let x_ = 0
      data.forEach(d=> {
        down
        .append('rect')
        .attr('id', `ICON_${d.code}_${this.localId}`)
        .attr('x', x_)
        .attr('y', (d.type=='LINE') ? 3 : 0)
        .attr('width', 6)
        .attr('height', (d.type=='LINE') ? 1 : 6)
        .attr('fill', d.color).attr('stroke', d.color)

        down
        .append('text')
        .attr('id', `LEGEND_${d.code}_${this.localId}`)
        .attr('transform', `translate(${x_ + 10}, ${3 + this.legends.tSize*0.36})`)
        .attr('font-size', this.legends.tSize).attr('fill', this.legends.tColor)
        .text(`${d.name} (${actData[d.code]})`)

        x_ = x_ + this.getNode(`#LEGEND_${d.code}_${this.localId}`, 'width') + 25
      })
    }
    
  }
}
           